// extracted by mini-css-extract-plugin
export var answer = "styles-module--answer--8cab8";
export var container = "styles-module--container--da04d";
export var contentContainer = "styles-module--contentContainer--ee0d7";
export var expanded = "styles-module--expanded--963a4";
export var header = "styles-module--header--6c18d";
export var icon = "styles-module--icon--98aa7";